import Swiper, { Navigation } from "../../assets/.npm/node_modules/swiper";

export default () => {

  const tabs = document.querySelectorAll('.product-tabs a');

  const productSwiper = new Swiper(".productSwiper", {
    modules: [Navigation],
    slidesPerView: 1,
    speed: 600,
    navigation: {
      nextEl: ".pro-next",
      prevEl: ".pro-prev",
    },
    on: {
      slideChange: function () {
        const index = this.realIndex;

        tabs.forEach(tab => tab.classList.remove('active'));

        const activeTab = document.querySelector(
          `.product-tabs a[data-slide="${index}"]`
        );

        if (activeTab) activeTab.classList.add('active');
      }
    }
  });

  // TAB → SLIDE
  tabs.forEach(tab => {
    tab.addEventListener('click', function (e) {
      e.preventDefault();

      tabs.forEach(t => t.classList.remove('active'));
      this.classList.add('active');

      const index = parseInt(this.dataset.slide, 10);
      productSwiper.slideToLoop(index);
    });
  });

};
